import { Box, Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { editIcon } from "../../icons/EditIcon";
import { RenewalStatus } from "../Case.types";
import { BulkRenewalAction } from "./bulkRenewal.functions";

export type BulkRenewalHeaderMenuProps = {
    onBulkActionSelected: (bulkAction: BulkRenewalAction) => void;
};

function BulkRenewalHeaderMenu(props: BulkRenewalHeaderMenuProps) {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const selectBulkAction = (bulkAction: BulkRenewalAction) => {
        props.onBulkActionSelected(bulkAction);
        setAnchorEl(null);
    };

    return (
        <>
            {/* Same button styling as RenewalOverflowMenu, so the icon lines up with the row menus below it */}
            <Button
                color={"primary"}
                sx={{ backgroundColor: "transparent", minWidth: "auto", borderRadius: "20px", border: "none" }}
                onClick={(event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)}
            >
                <Box width={24} display={"flex"} justifyContent={"center"}>
                    {editIcon}
                </Box>
            </Button>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)} autoFocus={false}>
                <MenuItem onClick={() => selectBulkAction(RenewalStatus.Renew)}>Bulk renew status</MenuItem>
                <MenuItem onClick={() => selectBulkAction(RenewalStatus.Expire)}>Bulk expire status</MenuItem>
            </Menu>
        </>
    );
}

export default BulkRenewalHeaderMenu;
